import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseAdvCustomer() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      companyName: isEmpty(state.companyName),
      contactPointMobile: isEmpty(state.contactPointMobile),
    };

    setter(errorState);

    if (errorState.companyName || errorState.contactPointMobile) {
      enqueueSnackbar("لطفا اطلاعات مشتری را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getAdvCustomerList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_AdvertisingCustomers?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllAdvCustomerList = (callback) => {
    MyAxios.get(`Admin_AdvertisingCustomers?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAdvCustomerByID = (id, callback) => {
    MyAxios.get(`Admin_AdvertisingCustomers/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateAdvCustomer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_AdvertisingCustomers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addAdvCustomer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_AdvertisingCustomers`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteAdvCustomer = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_AdvertisingCustomers`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getAdvCustomerList,
    getAllAdvCustomerList,
    getAdvCustomerByID,
    validate,
    updateAdvCustomer,
    addAdvCustomer,
    deleteAdvCustomer,
  };
}
